import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import appHelper from '@/utils/AppHelper'

export default new Vuex.Store({
  state: {
    count: 0,
    user: appHelper.getUserInfo(),
    lastBnavVal: 0
  },
  mutations: {
    increment(state) {
      state.count++
    },
    SET_USER(state, payload) {
      // if (payload.hasOwnProperty.call('acode')) {
      //   state.user.acode = payload.acode
      // }
      // if (payload.hasOwnProperty.call('openid')) {
      //   state.user.openid = payload.openid
      // }
      // if (payload.hasOwnProperty.call('nick_name')) {
      //   state.user.nick_name = payload.nick_name
      // }
      // if (payload.hasOwnProperty.call('head_url')) {
      //   state.user.head_url = payload.head_url
      // }
      // if (payload.hasOwnProperty.call('guid')) {
      //   state.user.guid = payload.guid
      // }
      // if (payload.hasOwnProperty.call('token')) {
      //   state.user.token = payload.token
      // }
      appHelper.setUserInfo(payload)
    },
    SET_FNAVVAL(state, val) {
      state.lastBnavVal = val
    }
  }
})
